import { useCallback } from 'react';

import { useAppDispatch } from '@src/core/hooks';
import type { SaleChange } from '@src/features/sales';
import { loadSaleChangeByIdAsCurrent, setCurrentSaleChange } from '@src/stores/saleChange';

export const useSaleChangeCheckout = () => {
  const dispatch = useAppDispatch();

  return useCallback(
    (saleChange: SaleChange) => {
      dispatch(setCurrentSaleChange(saleChange));
      // Refreshed in the background so the payment step reads the latest amounts.
      dispatch(loadSaleChangeByIdAsCurrent(saleChange.id));
    },
    [dispatch],
  );
};

export default useSaleChangeCheckout;
